import api from './api';

export interface PortalSetting {
  id: number;
  key: string;
  value: string;
  updatedAt: string;
}

export const settingsService = {
  async getAll(): Promise<PortalSetting[]> {
    const { data } = await api.get('/settings');
    return data;
  },

  async update(key: string, value: string): Promise<PortalSetting> {
    const { data } = await api.patch(`/settings/${key}`, { value });
    return data;
  },

  async isAiChatEnabled(): Promise<boolean> {
    const settings = await this.getAll();
    const setting = settings.find((s) => s.key === 'ai_chat_enabled');
    return setting ? setting.value === 'true' : true;
  },
};
